import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {Container} from 'reactstrap';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import SubNav from '../../components/SubNav/SubNav';
import Dashboard from '../../views/Dashboard/';

import Usuarios from '../../views/Usuarios/Usuarios/';
import Permisos from '../../views/Usuarios/Permisos/';
import Perfiles from '../../views/Usuarios/Perfiles/';
import Grupos from '../../views/Usuarios/Grupos/';
import Subgrupos from '../../views/Usuarios/Subgrupos/';
import Personal from '../../views/Usuarios/Personal/';

import Rubros from '../../views/clientes/Rubros/';
import ClasificacionEmpresa from '../../views/clientes/ClasificacionEmpresa/';
import Empresas from '../../views/clientes/Empresas/';
import Responsables from '../../views/clientes/Responsables/';


import Contactos from '../../views/Proyectos/Procedimiento0/';
import Solicitudes from '../../views/Proyectos/Procedimiento1/';
import PlanDeTrabajo from '../../views/Proyectos/Procedimiento2/';
import Presupuesto from '../../views/Proyectos/Procedimiento3/';
import CargaInforme from '../../views/Proyectos/Procedimiento4/';
import CargaDeDatos from '../../views/Proyectos/Procedimiento5/';
import EnvioDeMails from '../../views/Proyectos/Procedimiento6/';

import Pais from '../../views/misc/Pais/';

import Casillas from "../../views/Config/Casillas/";
import PlantillasEmail from '../../views/Config/Plantillas/';

import CamposDePlan from '../../views/ProyectosConfig/Plan_Campos/';
import MarcosDePlan from '../../views/ProyectosConfig/Plan_Marcos/';
import TiposDePlan from '../../views/ProyectosConfig/Plan_Tipos/';
import SubTiposDePlan from '../../views/ProyectosConfig/Plan_SubTipos/';

import Condiciones from '../../views/ProyectosConfig/Presupuesto_Condiciones/';
import Plazos from '../../views/ProyectosConfig/Presupuesto_Plazos/';
import TiposDeCosto from '../../views/ProyectosConfig/Presupuesto_TiposDeCosto/';
import Motivos from '../../views/ProyectosConfig/Presupuesto_Motivos/';
import UVT from '../../views/ProyectosConfig/Presupuesto_UVT/';

import CoeficientesUE from '../../views/ProyectosConfig/Presupuesto_CoeficientesUE/';
import CoeficientesGC from '../../views/ProyectosConfig/Presupuesto_CoeficientesGC/';


import Plantillas from '../../views/ProyectosConfig/Proyectos_Plantillas/';
import Roles from '../../views/ProyectosConfig/Proyectos_Roles/';
import Firmas from '../../views/ProyectosConfig/Firmas/';

import Facturacion from '../../views/Indicadores/Facturacion.js';
import VisualizadorProyectos from '../../views/Indicadores/VisualizadorProyectos.js';
import VisualizadorGlobal from '../../views/Indicadores/VisualizadorGlobal.js';
import Estadisticas from '../../views/Indicadores/Estadisticas.js';

import Certificacion from '../../views/Consultas/Certificacion.js';
import Productividad from '../../views/Consultas/Productividad.js';
import ParticipacionImputaciones from '../../views/Consultas/Imputaciones/Imputaciones.js';

import ProyectosAHistoricos from '../../views/ProyectosHistoricos/ProyectosAHistoricos.js';
import ProyectosHistoricos from '../../views/ProyectosHistoricos/ProyectosHistoricos.js';

import Imputaciones from '../../views/Imputaciones/Imputaciones/Imputaciones.js';
import TitulosSeparaciones from '../../views/Imputaciones/TitulosSeparaciones/TitulosSeparaciones.js';
import GestionProductividad from '../../views/Imputaciones/GestionProductividad';

import Tutoriales from '../../views/Tutoriales/Tutoriales';
import Convenios from '../../views/Convenios/Convenios';
import TiposConvenios from '../../views/Convenios/Tipos/TiposConvenios';
import DependenciasConvenios from '../../views/Convenios/Dependencias/DependenciasConvenios';
import ConsultaConvenios from '../../views/Consultas/Convenios/Convenios';

import Movimientos from '../../views/Saldos/Movimientos/Movimientos.js';
import Categorias from '../../views/Saldos/Categorias/Categorias.js';

class Full extends Component {
  render() {
    return (
      <div className="app">
        <Header />
        <div className="app-body">
          <Sidebar {...this.props}/>
          <main className="main">
            <SubNav path={this.props.location.pathname} />
            <Container fluid>
              <Switch>
                <Route path="/dashboard" name="Dashboard" component={Dashboard}/>

                <Route path="/usuarios/usuarios" name="Usuarios" component={Usuarios}/>
                <Route path="/usuarios/permisos" name="Permisos" component={Permisos}/>
                <Route path="/usuarios/perfiles" name="Perfiles" component={Perfiles}/>
                <Route path="/usuarios/grupos" name="Grupos" component={Grupos}/>
                <Route path="/usuarios/subgrupos" name="Subgrupos" component={Subgrupos}/>
                <Route path="/usuarios/personal" name="Personal" component={Personal}/>

                <Route path="/clientes/rubros" name="Rubros" component={Rubros}/>
                <Route path="/clientes/clasificacionempresas" name="clasificacionempresas" component={ClasificacionEmpresa}/>
                <Route path="/clientes/empresas" name="Empresas" component={Empresas}/>
                <Route path="/clientes/contactos" name="Responsables" component={Responsables}/>


                <Route path="/proyectos/gestion" name="Contactos" component={Contactos}/>
                <Route path="/proyectos/solicitudes" name="Solicitudes" component={Solicitudes}/>
                <Route path="/proyectos/planes" name="plandetrabajo" component={PlanDeTrabajo}/>
                <Route path="/proyectos/presupuestos" name="presupuesto" component={Presupuesto}/>
                <Route path="/proyectos/informes" name="cargadeinformes" component={CargaInforme}/>
                <Route path="/proyectos/certificacion" name="cargadedatos" component={CargaDeDatos}/>
                <Route path="/proyectos/informealcliente" name="enviodemails" component={EnvioDeMails}/>

                <Route path="/convenios/convenios" name="Convenios" component={Convenios} />
                <Route path="/convenios/tipos" name="tiposconvenios" component={TiposConvenios} />
                <Route path="/convenios/dependencias" name="dependenciasconvenios" component={DependenciasConvenios} />

                <Route path="/proyectosconfig/plantillas" name="plantillas" component={Plantillas}/>
                <Route path="/proyectosconfig/certificacion/roles" name="roles" component={Roles}/>
                <Route path="/proyectosconfig/certificacion/firmas" name="firmas" component={Firmas}/>

                <Route path="/proyectosconfig/plan/campos" name="camposdeplan" component={CamposDePlan}/>
                <Route path="/proyectosconfig/plan/modos" name="marcosdeplan" component={MarcosDePlan}/>
                <Route path="/proyectosconfig/plan/tipos" name="tiposdeplan" component={TiposDePlan}/>
                <Route path="/proyectosconfig/plan/subtipos" name="subtiposdeplan" component={SubTiposDePlan}/>

                <Route path="/proyectosconfig/presupuesto/monedas" name="condiciones" component={Condiciones}/>
                <Route path="/proyectosconfig/presupuesto/plazos" name="plazos" component={Plazos}/>
                <Route path="/proyectosconfig/presupuesto/tiposdecosto" name="tiposdecosto" component={TiposDeCosto}/>
                <Route path="/proyectosconfig/presupuesto/motivos" name="motivos" component={Motivos}/>
                <Route path="/proyectosconfig/presupuesto/uvt" name="uvt" component={UVT}/>

                <Route path="/proyectosconfig/presupuesto/coeficientesue" name="coeficientesue" component={CoeficientesUE}/>
                <Route path="/proyectosconfig/presupuesto/coeficientesgc" name="coeficientesgc" component={CoeficientesGC}/>


                <Route path="/indicadores/facturacion" name="facturacion" component={Facturacion} />
                <Route path="/indicadores/visualizadorproyectos" name="visualizadorproyectos" component={VisualizadorProyectos} />
                <Route path="/indicadores/visualizadorglobal" name="visualizadorglobal" component={VisualizadorGlobal} />
                <Route path="/indicadores/estadisticas" name="estadisticas" component={Estadisticas} />

                <Route path="/consultas/certificacion" name="certificacion" component={Certificacion} />
                <Route path="/consultas/productividad" name="productividad" component={Productividad} />
                <Route path="/consultas/imputaciones" name="ParticipacionImputaciones" component={ParticipacionImputaciones} />
                <Route path="/consultas/convenios" name="convenios" component={ConsultaConvenios} />

                <Route path="/config/paises" name="Pais" component={Pais} />

                <Route path="/config/email/casillas/" name="Casillas" component={Casillas} />
                <Route path="/config/email/plantillas/" name="Plantillas" component={PlantillasEmail} />

                <Route path="/historicos/proyectosahistoricos" name="ProyectosAHistoricos" component={ProyectosAHistoricos} />
                <Route path="/historicos/proyectoshistoricos" name="ProyectosHistoricos" component={ProyectosHistoricos} />

                <Route path="/imputaciones/imputaciones" name="Imputaciones" component={Imputaciones} />
                <Route path="/imputaciones/gestionproductividad" name="gestionproductividad" component={GestionProductividad} />
                <Route path="/imputaciones/parametros" name="ParametrosImputaciones" component={TitulosSeparaciones} />
                <Route path="/tutoriales" name="Tutoriales" component={Tutoriales} />

                <Route path="/saldos/movimientos" name="saldos-movimientos" component={Movimientos} />
                <Route path="/saldos/categorias" name="saldos-categorias" component={Categorias} />
                <Route path="/saldos/uvt" name="saldos-uvt" component={UVT}/>

                <Redirect from="/" to="/dashboard"/>
              </Switch>
            </Container>
          </main>
        </div>
      </div>
    );
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js